import "../scss/main.scss";
import { initAnimationToggle } from "./animation-toggle";
import { initArticleLightbox } from "./lightbox";

initAnimationToggle();
initArticleLightbox();
